module.exports = "app-servico-plano-table {\n    width: 100%;\n}\n.advanced {\n    border-bottom: 1px solid #edf0f4;\n}\n.advanced a {\n    cursor: pointer;\n    margin: 0;\n}\n\n.mb0 {\n    margin-bottom: 0;\n}\n\n.planoDescription {\n    margin: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/servicos/servico-bens/servico-bem-list/servico-bem-list.component.css
 ** module id = 445
 ** module chunks = 0
 **/